import { gql } from 'graphql-request';

export const UpdateStatusOfferingsActions = gql`
  mutation updateOfferingActions($input: UpdateOfferingActionsInput!) {
    updateOfferingActions(input: $input) {
      offeringId
      status
      actionRef
      operatorId
      userId
      id
      user {
        email
        id
      }
      offering {
        id
        name
        status
        operatorId
      }
      popUpsShown
    }
  }
`;
